


    <div class="nsw-block">
        <h1>How we report</h1>
        <p class="nsw-intro">Find out how Beachwatch and our partners check and report whether beaches are safe for swimming.</p>
    </div>

    <nav class="nsw-in-page-nav bw-in-page-nav" aria-labelledby="in-page-nav">
        <div id="in-page-nav" class="nsw-in-page-nav__title">On this page</div>
        <ul>
            <li>
                <a [routerLink]="['./']" fragment="introduction">Information on safe swim sites</a>
            </li>
            <li>
                <a [routerLink]="['./']" fragment="waterQualityForecast">Water quality forecast</a>
            </li> 
            <li>
                <a [routerLink]="['./']" fragment="latestWaterQualityResults">Latest water quality results</a>
            </li>
            <li>
                <a [routerLink]="['./']" fragment="annualbeachGrades">Annual beach grades</a>
            </li>
            <li>
                <a [routerLink]="['./']" fragment="exploreWaterQualityData">Water quality data</a>
            </li>           
        </ul>
    </nav> 


    <section class="nsw-section nsw-section--padding" id="introduction">
        <div class="nsw-block">
            <h2 id="introductionTitle">Information on safe swim sites</h2>
            <p>  
                Beachwatch provides regular and reliable recreational water quality information to help people decide when and where to swim. Beachwatch forecasts provide guidance on water quality to help you decide if and when to swim. For each monitored swim site, we provide the latest water quality results and annual beach grades that  are reported  in the State of the Beaches report.
            </p>                   
        </div>               
    </section>

    <section class="nsw-section nsw-section--padding" id="waterQualityForecast">
        <div class="nsw-block">
            <h2 id="waterQualityForecastTitle">Water quality forecast</h2>
            <p>  
                Beachwatch daily pollution forecasts provide the latest recreational water quality conditions at many locations to let you know if they are suitable for swimming. 
                This predictive modelling allows timely warnings to water users so they can make informed choices about 
                <app-external-link text="when and where to swim" link="home" [isExternalLink]="false"></app-external-link>.
                <br/>
                <br/>
                <app-external-link text="More information on how we forecast." link="/whatIsBeachwatch/safeToSwim" 
                    [isExternalLink]="false">
                </app-external-link>.                
            </p>                   
        </div>               
    </section>

    <section class="nsw-section nsw-section--padding" id="latestWaterQualityResults">
        <div class="nsw-block">
            <h2 id="latestWaterQualityResultsTitle">Latest water quality results</h2>
            <p>  
                Star ratings are generated for each swim site based on the number of bacteria <i>(enterococci)</i> in the most recent water sample. 
                The latest water quality result is rated from 1 to 4 stars to indicate suitability for swimming. 
                <br/><br/>
                Latest results are available for all <app-external-link text="monitored swim sites" link="home" [isExternalLink]="false"></app-external-link>.
            </p>                   
        </div>               
    </section>

    <section class="nsw-section nsw-section--padding" id="annualbeachGrades">
        <div class="nsw-block">
            <h2 id="annualbeachGradesTitle">Annual grades</h2>
            <p>  
                Annual grades, also known as Beach Suitability Grades, provide a long-term assessment of how suitable a site is for swimming. 
                Swim sites are categorised by a combination of sanitary inspection and microbial water-quality assessment. This approach provides information on where pollution may have come from, as well as information on the likely level of faecal pollution.
                <br/><br/>
                Swimming sites are graded as Very Good, Good, Fair, Poor or Very Poor and reported at the start of summer each year in the
                <a (mousedown)="navigateToStateOfBeaches()">                <app-external-link text="State of the Beaches report" 
                    [link]="STATE_OF_BEACHES_REPORT_URL">
                </app-external-link>. </a>

            </p>                   
        </div>               
    </section>

    <section class="nsw-section nsw-section--padding" id="exploreWaterQualityData">
        <div class="nsw-block">
            <h2 id="exploreWaterQualityDataTitle">Water quality data</h2>
            <p>  
                The water quality data collected under the Beachwatch program can be viewed or downloaded. Results are usually updated within one week of sample collection.
                <br/><br/>
                <app-external-link 
                    text="Explore water quality data" 
                    link="/waterMonitoring/waterQualityData"
                    [isExternalLink]="false">
                </app-external-link>. 
            </p>                   
        </div>               
    </section>
